import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type Policy from 'modules/payroll_bundle/store/models/Policy'

interface Props {
  onConfirm: (closePortal: () => void) => Promise<void>
  onClose: () => void
  policy: Policy
  openingNext: boolean
}

const OpenPeriodModal = ({ onConfirm, onClose, policy, openingNext }: Props) => {
  const title = i18n.t('payroll_bundle.policy_period.open_period_modal.title')

  const description = openingNext
    ? i18n.t('payroll_bundle.policy_period.open_period_modal.next_description', {
        policyName: policy.attributes.name,
      })
    : i18n.t('payroll_bundle.policy_period.open_period_modal.previous_description', {
        policyName: policy.attributes.name,
      })

  return (
    <Modal
      illustration="money-bag"
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={onConfirm}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.confirm')}</Button>
        </>
      }
    />
  )
}

export default observer(OpenPeriodModal)
